import { FunctionalComponent, h } from 'preact';

export const FullDollarIcon: FunctionalComponent<{ color?: string }> = ({ color }) => {
  if (!color) {
    color = 'black';
  }
  return (
    <svg width="50" height="68" viewBox="0 0 50 68" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M49.3663 42.9326C49.3663 33.8876 43.5354 28.2135 33.5917 26.1348L24.7466 24.2809C24.0424 24.1404 23.817 23.6629 23.817 23.1292C23.817 22.3708 24.5776 21.8933 25.5917 21.8933C31.9015 21.8933 38.8875 25.264 38.8875 25.264L47.0283 12.0056C43.648 9.89887 40.1832 8.12921 35.8452 7.0337V0.264038H14.9156V7.65168C7.25366 10.2359 2.23957 15.7697 2.23957 23.8876C2.23957 32.9326 8.32408 38.7753 17.1692 40.6011L26.0987 42.4551C26.803 42.5955 27.0283 42.9888 27.0283 43.5225C27.0283 44.3652 26.4086 44.8146 25.2537 44.8146C18.9438 44.8146 13.7889 43.3539 8.4931 40.3764L0.662109 53.0168C4.26774 56.1629 9.16915 58.7472 14.9438 60.1798V67.7079H35.8452V59.8427C44.2677 57.1742 49.3663 51.1629 49.3663 42.9326Z" fill={color} />
    </svg>
  )
};